import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import vrBanner from "../images/vr-1.png";
import vrBig from "../images/vr-2.png";
import vrCollage from "../images/vr-3.png";

import {
  FaWifi,
  FaShieldAlt,
  FaCube,
FaBrain ,
 FaCertificate
} from "react-icons/fa";

export default function VR() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const sidebar = [
  {
    title: "Works Offline",
    icon: FaWifi,
  },
  {
    title: "Safe & Easy for Teachers",
    icon: FaShieldAlt,
  },
  {
    title: "3D Visual Learning (Higher Retention)",
    icon: FaCube,
  },
  {
    title: "Understanding Complex Concepts",
    icon: FaBrain,
  },
  {
    title: "Teacher Certification & Support",
    icon: FaCertificate,
  },
];

  const features = [
    "Custom VR solutions for training & demos",
    "Interactive 3D simulations",
    "VR hardware procurement",
    "UI/UX for immersive experiences",
    "Deployment & maintenance",
  ];

  return (
    <ServiceTemplate
      title="VR Gadgets"
      bannerImage={vrBanner}
      bigImage={vrBig}
      collageImage={vrCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}
